const Loader = () => (
    <div className="loading">
        <div className="loader" />
    </div>
);

export default Loader;
